// test608
(608 && 0);
